<template>
  <img
    src="../../assets/images/city-background.jpg"
    alt="contact-image"
    class="image-background-login"
  />
  <RegisterContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import RegisterContent from "../../components/Authentication/RegisterContent.vue";

export default defineComponent({
  name: "RegisterPage",
  components: {
    RegisterContent,
  },
});
</script>